module.exports = __webpack_public_path__ + "fonts/avenir/2927FA_2_0.eot";